
export default (props, inject) => {
  const additionalBlockClasses = function (cfgs = {}) {
    let classes = [];

    // Отображение в различных версиях
    if (cfgs?.visible_mobile || cfgs?.visible_laptop || cfgs?.visible_pc) {
      classes.push('section-visible');
      if (cfgs?.visible_mobile) {
        classes.push('--mobile');
      }
      if (cfgs?.visible_laptop) {
        classes.push('--laptop');
      }
      if (cfgs?.visible_pc) {
        classes.push('--pc');
      }
    }

    return classes.join(" ")
  }
  inject('additionalBlockClasses', additionalBlockClasses)
}
